import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 460px;
  overflow-y: scroll;
`;

export const Item = styled.div`
  :not(:last-child) {
    margin-bottom: 5px;
  }
  label {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-family: Roboto;
    font-weight: 400;

    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #808080;
    cursor: pointer;
    input {
      margin-right: 8px;
      width: 15px;
    }
  }
`;
